export default "__VITE_ASSET__COFR4JH0__"